<template lang="html">
<div class="coupon-agreement">
  <row>
    <div class="sl-col-4">
      <div class="sl-coupon-form">
        <div class="title">{{$t('Views.CouponAgreement.title')}}</div>
        <div class="content">
          <ul>
            <li v-for="item in cnt">{{item}}</li>
          </ul>
        </div>
        <div class="checkbox">
          <el-checkbox v-model="agree"></el-checkbox>
          <span>{{$t('Views.CouponAgreement.btn')}}</span>
        </div>
        <div class="confirm">
          <el-button :disabled="!agree" @click="handleAgree" :loading="btnLoading">{{$t('Functional.confirm')}}</el-button>
        </div>
      </div>
    </div>
  </row>
</div>
</template>
<script>
import api from '../../api'
import * as types from '../../store/types'
export default {
  data() {
    return {
      btnLoading: false,
      agree: false,
      cnt: [
        'The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99',
        'The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99。The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99',
        'The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99',
        'The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99。The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99'
      ]
    }
  },
  methods: {
    handleAgree() {
      this.$ga.event('Button', 'Confirm', 'Agreement')
      this.btnLoading = true
      const vm = this
      api.agreeCoupon({
        agreeCoupon: '1'
      }).then(res => {
        if (res.data.code === 200) {
          vm.$store.commit(types.AGREECOUPON)
          this.btnLoading = false
          vm.$router.push({
            name: 'Choose-Coupon'
          })
        } else {
          vm.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>
<style scoped>
.sl-coupon-form {
  padding-bottom: 30px;
}

.sl-coupon-form>div {
  padding: 20px;
}

.sl-coupon-form .title {
  font-family: Avenir-Medium;
  font-size: 18px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
}

.sl-coupon-form .content {
  max-width: 700px;
  margin: 0 auto;
  padding: 30px 20px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
}

.sl-coupon-form .content li {
  font-family: Avenir-Book;
  font-size: 12px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 16px;
  padding: 15px 0;
  text-align: center;
}

.sl-coupon-form .checkbox {
  text-align: center;
}

.sl-coupon-form .checkbox span {
  display: inline-block;
  padding-left: 10px;
  font-family: Avenir-Book;
  font-size: 12px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 16px;
}

.sl-coupon-form .confirm {
  text-align: center;
}

.sl-coupon-form button {
  border: 1px solid #2B90E9;
  font-size: 15px;
  color: #2B90E9;
  letter-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// agreement.vue?fab4d350